<template>
    <div v-if="show"  class="root flex flex-col border-box">
        <div  class="version-info border flex-col" @click="stopPropa">
            <div v-for="item,index in data" class="flex flex-row flex-space-between padding-s font-s flex-center-cz">
                <div class="flex flex-center-cz">
                    <div>{{item.createTime}} </div>
                    <img v-if="index == 0" src="@/assets/images/new.png" class="margin-left-s" style="width: 30px;">
                </div>
                <div class="color-blue pointer flex">
                    <div class="margin-right-m" @click="view(item)">查看</div>
                    <div @click="down(item.fileUrl)">下载</div>
                </div>
            </div>
        <div class="sjx"></div>  
      </div>
    </div>
</template>

<script>
    import {strToInt, debounce} from '@/utils/sysUtils.js'
    export default{
        name:'FileVer',
        props:{
            show:{},
            data:{}
        },
        data() {
            return {
            }
        },
        methods:{
            stopPropa(event) {
                event || (event = window.event);
                event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
            },
            down: debounce(
                function(fileUrl) {
                    console.log(fileUrl);
                    window.open(fileUrl ,"_self");
                }, 1000, true
            ),
            view: debounce(
                function(item) {
                    this.$emit("change", item);
                }, 1000, true
            ),
        },
        
    }
</script>

<style scoped>
    .version-info {
        position: absolute;
        background-color: #fff;
        border-radius: 10px;
        top:55px;
        right: 250px;
        width: 250px;
        z-index: 999;
        display: flex;
        flex-direction: column;
        padding: 10px;
    }
    .sjx {
        transform: rotate(45deg);
        top: -7px;
        left: 27px;
        width: 10px;
        height: 10px;
        position: absolute;
        border-left: 1px solid rgba(0, 0, 0, .2);
        border-top: 1px solid rgba(0, 0, 0, .2);
        z-index: 9999;
        background-color: #fff;
    }

</style>


// WEBPACK FOOTER //
// src/modules/fileVer/FileVer.vue